import { render, staticRenderFns } from "./OrderVolumeDiscount.vue?vue&type=template&id=57d87ae7&"
import script from "./OrderVolumeDiscount.vue?vue&type=script&lang=js&"
export * from "./OrderVolumeDiscount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports